import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Title,
  Copy,
  Bold,
  Card,
  Input,
  Spin
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

class Buttons extends Component {
  componentDidMount() {}

  renderButton() {
    const {
      location_success,
      name_success,
      preset_success,
      smart_success,
      startBuilding,

      get_list_count_loading,
      get_list_count,
      route_plan,
      lists_info_banner
    } = this.props;

    if (
      location_success &&
      preset_success &&
      name_success &&
      smart_success &&
      !route_plan &&
      get_list_count > 0 &&
      !get_list_count_loading
    ) {
      const new_list_count =
        parseInt(lists_info_banner.current_count) + parseInt(get_list_count);
      if (
        new_list_count <= parseInt(lists_info_banner.limit) ||
        lists_info_banner.limit == -1
      ) {
        return (
          <Row style={{ justifyContent: "flex-end" }}>
            <PillButton
              primary={true}
              onPress={() => {
                startBuilding();
              }}
            >
              Submit
            </PillButton>
          </Row>
        );
      }
    }
  }

  render() {
    const { location_success, preset_success } = this.props;

    if (location_success && preset_success) {
      return <Wrapper>{this.renderButton()}</Wrapper>;
    }

    return <Wrapper />;
  }
}

export default Buttons;
